import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../../css/accomodation/ManageAccomodation.css";
import "../../css/Manage.css";
import AccomodationApi from "../../api/accomodationApi";
import { toast } from "react-toastify";
import AlertPopup from "../../components/AlertPopup";
import { saveAs } from "file-saver";

const ManageAccomodation = () => {
  let navigate = useNavigate();

  //--삭제 state--//
  const [isOpen, setIsOpen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("삭제 하시겠습니까?");
  const [content, setContent] = useState(
    "삭제된 데이터는 복구가 불가능합니다."
  );
  const [alertValue, setAlertValue] = useState(false);
  const [cancelTitle, setCancelTitle] = useState("취소");
  const [confirmTitle, setConfirmTitle] = useState("삭제");
  //--삭제 state--//

  //------------엑셀 생성
  const downloadExcel = async () => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "숙소명", key: "name", width: 40 },
      { header: "업체명", key: "companyName", width: 40 },
      { header: "담당자명", key: "managerName", width: 40 },
      { header: "휴대전화", key: "phoneNumber", width: 40 },
    ];

    excel.map((item, index) => {
      // 행 추가
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "숙소 관리.xlsx");
  };
  //------------액셀 부분 끝

  //
  const [arr, setArr] = useState([]);
  const [excel, setExcel] = useState([]);

  const [accomodationData, setAccomodationData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    getAccomodationList();
  }, []);

  const getAccomodationList = async () => {
    try {
      const response = (await AccomodationApi.Get()).data.data;
      // API 응답이 배열인지 확인하고 처리
      const list = Array.isArray(response) ? response : response?.content || [];
      setAccomodationData(list);
      setTotalCount(response?.totalCount || list.length);
    } catch (err) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  const delAccomodation = async (id) => {
    setIsOpen(true);
    setDeleteId(id);
  };

  const [deleteId, setDeleteId] = useState(-1);
  useEffect(() => {
    const del = async () => {
      try {
        if (deleteId <= 0) {
          return;
        }
        await AccomodationApi.Del(deleteId);
        toast("삭제되었습니다.");
        getAccomodationList();
        setAlertValue(false);
        setDeleteId(-1);
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
        setAlertValue(false);
      }
    };
    if (alertValue) {
      del();
    }
  }, [alertValue]);

  // 검색 필터링
  const filteredData = (
    Array.isArray(accomodationData) ? accomodationData : []
  ).filter((item) => {
    if (!searchKeyword) return true;
    return (
      item.name?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.companyName?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.managerName?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.phoneNumber?.includes(searchKeyword)
    );
  });

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table">
        <span>숙소 관리</span>
        <div className="manage-table-container">
          <div className="Manage-accomodation-search-container">
            <div className="Manage-accomodation-search-number">
              <span>전체 갯수</span>
              <span>{filteredData.length}</span>
            </div>
            <div className="Manage-accomodation-search">
              <div style={{ position: "relative" }}>
                <input
                  className="table-search-input"
                  type="text"
                  placeholder="검색어를 입력하세요"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                />
                <img
                  src="/img/search.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    right: "5px",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div
                className="cursorPointer"
                onClick={() => navigate("/admin/accomodation/add")}
              >
                <img src="\img\see-more-btn-plus.svg" />
                <span>숙소 추가</span>
              </div>
              <div onClick={downloadExcel} className="cursorPointer">
                <img src="\img\download.svg" />
                <span>엑셀로 내보내기</span>
              </div>
            </div>
          </div>
          <div className="Manage-table manage-table-accomodation">
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      className="cursorPointer all-check-input"
                      type="checkbox"
                      id={"check"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          let obj = [];
                          const temp = filteredData.map((value) => value.id);
                          const excelTemp = filteredData.map((item) => {
                            obj.push({
                              name: item.name,
                              companyName: item.companyName,
                              managerName: item.managerName,
                              phoneNumber: item.phoneNumber,
                            });
                          });
                          setArr(temp);
                          setExcel(obj);
                        } else {
                          setArr([]);
                          setExcel([]);
                        }
                      }}
                    ></input>
                    <label
                      className="all-check-label"
                      htmlFor={"check"}
                    ></label>
                  </th>
                  <th>숙소명</th>
                  <th>주소</th>
                  <th>상세 주소</th>
                  <th>삭제</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <input
                          className="cursorPointer"
                          type="checkbox"
                          id={"check" + index}
                          checked={arr.includes(item.id)}
                          onChange={(e) => {
                            let obj = {
                              name: item.name,
                              companyName: item.companyName,
                              managerName: item.managerName,
                              phoneNumber: item.phoneNumber,
                            };
                            let copyData = [...arr];
                            let copyExcel = [...excel];
                            if (e.target.checked) {
                              copyData.push(item.id);
                              copyExcel.push(obj);
                              setArr(copyData);
                              setExcel(copyExcel);
                            } else {
                              let arrTemp = copyData.filter(
                                (item02) => item02 !== item.id
                              );
                              let excelTemp = copyExcel.filter(
                                (item02) => item02.name !== item.name
                              );
                              setArr(arrTemp);
                              setExcel(excelTemp);
                            }
                          }}
                        ></input>
                        <label htmlFor={"check" + index}></label>
                      </td>
                      <td>{item.name}</td>
                      <td>{item.address}</td>
                      <td>{item.addressDetail}</td>
                      <td>
                        <div>
                          <Link onClick={() => delAccomodation(item.id)}>
                            삭제
                          </Link>
                        </div>
                      </td>
                      <td>
                        <div>
                          <Link
                            to={`/admin/accomodation/detail/${item.id}`}
                            state={{ id: item.id }}
                          >
                            <img src="\img\see-more-btn-plus.svg" />
                            <span>보기</span>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {/* 삭제 컴포넌트 */}
        <AlertPopup
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          headerTitle={headerTitle}
          content={content}
          setAlertValue={setAlertValue}
          cancelTitle={cancelTitle}
          confirmTitle={confirmTitle}
        />
      </section>
    </div>
  );
};

export default ManageAccomodation;
